export type IntegrationToastKind = "success" | "warning" | "error";

const TOAST_ICONS: Record<IntegrationToastKind, string> = {
    success: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>',
    warning: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>',
    error: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>'
};

let toastTimer: number | null = null;

export function showIntegrationToast(message: string, kind: IntegrationToastKind = "success"): void {
    const toast = document.getElementById("int-toast");
    if (!toast || !message) return;

    toast.innerHTML = "";
    toast.classList.toggle("toast--success", kind === "success");
    toast.classList.toggle("toast--warning", kind === "warning");
    toast.classList.toggle("toast--error", kind === "error");
    toast.insertAdjacentHTML("beforeend", TOAST_ICONS[kind]);
    const span = document.createElement("span");
    span.textContent = message;
    toast.appendChild(span);

    toast.classList.add("show");
    if (toastTimer) window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => toast.classList.remove("show"), 7000);
}

export function showIntegrationFlash(): void {
    const flash = document.getElementById("int-flash");
    if (!flash) return;

    if (flash.dataset.notice) showIntegrationToast(flash.dataset.notice, "success");
    else if (flash.dataset.warning) showIntegrationToast(flash.dataset.warning, "warning");
    else if (flash.dataset.alert) showIntegrationToast(flash.dataset.alert, "error");
}

(window as any).integrationToast = showIntegrationToast;
